import { faMapMarkerExclamation, faCreditCard } from '@fortawesome/pro-regular-svg-icons';

export default [faMapMarkerExclamation, faCreditCard];
